module.exports = require('./helpers/bundle-url').getBundleURL('at9U0') + "logo-dark.eefe0b7f.svg";